import React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

/**
 * shadcn/ui Tabs (ported) — same component API as the official shadcn tabs,
 * styled with the Pram Express px design tokens instead of Tailwind classes.
 *
 * Usage (identical to shadcn):
 *   <Tabs defaultValue="wallet">
 *     <TabsList>
 *       <TabsTrigger value="wallet">My Wallet</TabsTrigger>
 *       <TabsTrigger value="credit">My Credit Score</TabsTrigger>
 *     </TabsList>
 *     <TabsContent value="wallet">...</TabsContent>
 *     <TabsContent value="credit">...</TabsContent>
 *   </Tabs>
 */

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={`px-tabslist${className ? ` ${className}` : ''}`}
        {...props}
    />
));
TabsList.displayName = "TabsList";

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={`px-tabstrigger${className ? ` ${className}` : ''}`}
        {...props}
    />
));
TabsTrigger.displayName = "TabsTrigger";

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={`px-tabscontent${className ? ` ${className}` : ''}`}
        {...props}
    />
));
TabsContent.displayName = "TabsContent";

export { Tabs, TabsList, TabsTrigger, TabsContent };
